package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class FavoriteTemplateQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> all(mapper: (
    id: String,
    description: String?,
    amountCents: Long,
    categoryId: String,
    logoEmoji: String?,
    logoUri: String?,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(1_814_025_462, arrayOf("FavoriteTemplateEntity"), driver,
      "FavoriteTemplate.sq", "all",
      "SELECT FavoriteTemplateEntity.id, FavoriteTemplateEntity.description, FavoriteTemplateEntity.amountCents, FavoriteTemplateEntity.categoryId, FavoriteTemplateEntity.logoEmoji, FavoriteTemplateEntity.logoUri, FavoriteTemplateEntity.isDeleted, FavoriteTemplateEntity.createdAtEpochMs, FavoriteTemplateEntity.updatedAtEpochMs FROM FavoriteTemplateEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1),
      cursor.getLong(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getBoolean(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!
    )
  }

  public fun all(): Query<FavoriteTemplateEntity> = all { id, description, amountCents, categoryId,
      logoEmoji, logoUri, isDeleted, createdAtEpochMs, updatedAtEpochMs ->
    FavoriteTemplateEntity(
      id,
      description,
      amountCents,
      categoryId,
      logoEmoji,
      logoUri,
      isDeleted,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    id: String,
    description: String?,
    amountCents: Long,
    categoryId: String,
    logoEmoji: String?,
    logoUri: String?,
    isDeleted: Boolean,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(-1_364_360_774,
        """INSERT OR REPLACE INTO FavoriteTemplateEntity VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)""", 9) {
          bindString(0, id)
          bindString(1, description)
          bindLong(2, amountCents)
          bindString(3, categoryId)
          bindString(4, logoEmoji)
          bindString(5, logoUri)
          bindBoolean(6, isDeleted)
          bindLong(7, createdAtEpochMs)
          bindLong(8, updatedAtEpochMs)
        }.await()
    notifyQueries(-1_364_360_774) { emit ->
      emit("FavoriteTemplateEntity")
    }
  }
}
